import "core-js/modules/es.array.reduce.js";
import e, { useReducer as n, useEffect as r, useMemo as t, useContext as o, createContext as a, useState as i, useCallback as l, forwardRef as c, useRef as s } from "react";
import d from "lodash/debounce";
import { transparentize as u } from "polished";
import { css as p, cx as f } from "@leafygreen-ui/emotion";
import { fontFamilies as m } from "@leafygreen-ui/tokens";
import { palette as h, uiColors as g } from "@leafygreen-ui/palette";
import { useViewportSize as y, useIsomorphicLayoutEffect as b, useIdAllocator as v } from "@leafygreen-ui/hooks";
import { useBaseFontSize as w } from "@leafygreen-ui/leafygreen-provider";
import { isComponentType as x, createDataProp as k, enforceExhaustive as E } from "@leafygreen-ui/lib";
import { Transition as S } from "react-transition-group";
import N from "@leafygreen-ui/icon-button";
import O from "@leafygreen-ui/icon/dist/ChevronRight";
import C from "@leafygreen-ui/icon/dist/ChevronDown";
import j from "@leafygreen-ui/icon/dist/SortAscending";
import R from "@leafygreen-ui/icon/dist/SortDescending";
import A from "@leafygreen-ui/icon/dist/Unsorted";

function T(e, n) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, t);
  }

  return r;
}

function P(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? T(Object(r), !0).forEach(function (n) {
      z(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : T(Object(r)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }

  return e;
}

function z(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function F() {
  return F = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }

    return e;
  }, F.apply(this, arguments);
}

function H(e, n) {
  if (null == e) return {};

  var r,
      t,
      o = function (e, n) {
    if (null == e) return {};
    var r,
        t,
        o = {},
        a = Object.keys(e);

    for (t = 0; t < a.length; t++) {
      r = a[t], n.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }(e, n);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (t = 0; t < a.length; t++) {
      r = a[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }

  return o;
}

function I(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function D(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == r) return;
    var t,
        o,
        a = [],
        i = !0,
        l = !1;

    try {
      for (r = r.call(e); !(i = (t = r.next()).done) && (a.push(t.value), !n || a.length !== n); i = !0) {
        ;
      }
    } catch (e) {
      l = !0, o = e;
    } finally {
      try {
        i || null == r.return || r.return();
      } finally {
        if (l) throw o;
      }
    }

    return a;
  }(e, n) || W(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function M(e) {
  return function (e) {
    if (Array.isArray(e)) return _(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || W(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function W(e, n) {
  if (e) {
    if ("string" == typeof e) return _(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _(e, n) : void 0;
  }
}

function _(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var r = 0, t = new Array(n); r < n; r++) {
    t[r] = e[r];
  }

  return t;
}

var B = "REGISTER_COLUMN_INFO",
    L = "SET_HAS_NESTED_ROWS",
    U = "SET_HAS_ROW_SPAN",
    V = "SET_DATA",
    G = {
  Number: "number",
  Weight: "weight",
  ZipCode: "zipCode",
  String: "string",
  Date: "date"
},
    J = a({
  state: {
    data: []
  },
  dispatch: function dispatch() {}
});

function q(e, n) {
  switch (n.type) {
    case U:
      return P(P({}, e), {}, {
        hasRowSpan: n.payload
      });

    case L:
      return P(P({}, e), {}, {
        hasNestedRows: n.payload
      });

    case B:
      return P(P({}, e), {}, {
        columnInfo: P(P({}, e.columnInfo), {}, z({}, n.payload.index, {
          dataType: n.payload.dataType
        }))
      });

    case V:
      return P(P({}, e), {}, {
        data: n.payload
      });

    default:
      return e;
  }
}

function Z(o) {
  var a = o.children,
      i = o.data,
      l = D(n(q, {
    data: i,
    hasNestedRows: !1
  }), 2),
      c = l[0],
      s = l[1];
  r(function () {
    s({
      type: V,
      payload: i
    });
  }, [i]);
  var d = t(function () {
    return {
      state: c,
      dispatch: s
    };
  }, [c, s]);
  return e.createElement(J.Provider, {
    value: d
  }, a);
}

function $() {
  return o(J);
}

var K = ["children", "className"];

function Q(n) {
  var r = n.children,
      t = n.className,
      o = H(n, K);
  return e.createElement("tr", F({}, o, {
    className: t,
    "data-testid": "leafygreen-ui-header-row"
  }), r);
}

function X(n) {
  var r = n.columns,
      t = void 0 === r ? [] : r,
      o = e.useRef(!1);

  var a = function n(r) {
    return r.map(function (r, t) {
      var a = {
        key: t,
        index: t
      };

      if (x(r, "HeaderRow")) {
        o.current = !0;
        var i = (null == r ? void 0 : r.props).children;
        return e.cloneElement(r, {
          children: n(e.Children.toArray(i))
        });
      }

      return x(r, "TableHeader") ? e.cloneElement(r, a) : r;
    });
  }(t.type === e.Fragment || x(t, "HeaderRow") ? e.Children.toArray(t.props.children) : t);

  return o.current ? e.createElement("thead", null, a) : e.createElement("thead", null, e.createElement(Q, null, a));
}

Q.displayName = "HeaderRow";
var Y = a({
  sort: void 0,
  setSort: function setSort() {}
});

function ee(n) {
  var r = n.children,
      o = D(i(void 0), 2),
      a = o[0],
      l = o[1],
      c = t(function () {
    return {
      sort: a,
      setSort: l
    };
  }, [a, l]);
  return e.createElement(Y.Provider, {
    value: c
  }, r);
}

function ne() {
  return o(Y);
}

var re = new Intl.Collator(void 0, {
  numeric: !0,
  sensitivity: "base"
}),
    te = function te(e) {
  var n = e.direction,
      r = e.accessorValue,
      t = e.compareFn;
  return r ? function (e, t) {
    var o = r(e),
        a = r(t);
    return "desc" !== n ? re.compare(o, a) : re.compare(a, o);
  } : t ? function (e, r) {
    return t(e, r, n);
  } : void console.error("Error getting Table data comparison function. Please supply either an `accessorValue` or `compareFn`");
};

function oe(n) {
  var r = n.children,
      o = $().state.data,
      a = ne().sort,
      i = t(function () {
    if (a) {
      var e = a.direction,
          n = a.accessorValue,
          r = a.compareFn;
      if (r) return te({
        direction: e,
        compareFn: r
      });
      if (n) return te({
        direction: e,
        accessorValue: n
      });
    }
  }, [a]),
      c = function (n, r, o) {
    var a = t(function () {
      var t = new Map();
      return n.forEach(function (n, o) {
        return t.set(n, e.createElement(e.Fragment, {
          key: o
        }, r(n)));
      }), t;
    }, [n, r]);
    return t(function () {
      return o ? M(n).sort(o).map(function (e) {
        return a.get(e);
      }) : Array.from(a.values());
    }, [n, a, o]);
  }(o, l(function (e) {
    return r({
      datum: e
    });
  }, [r]), i);

  return e.createElement("tbody", null, c);
}

oe.displayName = "TableBody";
var ae = a(14);

function ie(n) {
  var r = n.children,
      t = n.baseFontSize;
  return e.createElement(ae.Provider, {
    value: t
  }, r);
}

function le() {
  return o(ae);
}

var ce = a(!1);

function se(n) {
  var r = n.children,
      t = n.darkMode;
  return e.createElement(ce.Provider, {
    value: t
  }, r);
}

function de() {
  return o(ce);
}

var ue,
    pe,
    fe,
    me,
    he,
    ge,
    ye,
    be,
    ve,
    we,
    xe,
    ke,
    Ee = ["columns", "data", "children", "className", "baseFontSize", "darkMode"],
    Se = u(.7, h.black),
    Ne = u(.2, g.black),
    Oe = p(ue || (ue = I(["\n  position: relative;\n  max-width: 100%;\n"]))),
    Ce = p(pe || (pe = I(["\n  font-family: ", ";\n  position: relative;\n  border-collapse: collapse;\n  box-sizing: border-box;\n  width: 100%;\n  z-index: 0;\n"])), m.default),
    je = p(fe || (fe = I(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 16px;\n  overflow: hidden;\n  pointer-events: none;\n\n  &:after {\n    opacity: 0;\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 16px;\n    border-radius: 100%;\n    transition: opacity 150ms ease-in-out;\n  }\n"]))),
    Re = function Re(e) {
  return p(me || (me = I(["\n  left: 0;\n\n  &:after {\n    right: 100%;\n    box-shadow: 4px 0 4px ", ";\n  }\n"])), e ? Ne : Se);
},
    Ae = function Ae(e) {
  return p(he || (he = I(["\n  right: 0;\n\n  &:after {\n    left: 100%;\n    box-shadow: -4px 0 4px ", ";\n  }\n"])), e ? Ne : Se);
},
    Te = p(ge || (ge = I(["\n  &:after {\n    opacity: 1;\n  }\n"]))),
    Pe = "none",
    ze = "left",
    Fe = "right",
    He = "both";

function Ie(n) {
  var r = n.columns,
      t = void 0 === r ? [] : r,
      o = n.data,
      a = void 0 === o ? [] : o,
      i = n.children,
      l = n.className,
      c = n.baseFontSize,
      s = n.darkMode,
      u = void 0 !== s && s,
      h = H(n, Ee),
      v = D(e.useState(Pe), 2),
      x = v[0],
      k = v[1],
      E = e.useRef(null),
      S = y(),
      N = w(),
      O = null != c ? c : 14 === N || 16 === N ? N : 14;
  b(function () {
    var e = E.current;
    null != e && (e.scrollWidth > e.clientWidth ? k(Fe) : null != S && e.getBoundingClientRect().width <= S.width && k(Pe));
  }, [S]);
  var C = d(function (e) {
    var n = e.target,
        r = n.scrollWidth,
        t = n.clientWidth;

    if (r > t) {
      var o = e.target.scrollLeft,
          a = r - t;
      o > 0 && o < a ? k(He) : o > 0 ? k(ze) : o < a && k(Fe);
    }
  }, 50, {
    leading: !0
  }),
      j = x === ze || x === He,
      R = x === Fe || x === He;
  return e.createElement("div", {
    className: Oe
  }, e.createElement("div", {
    className: f(je, Re(u), z({}, Te, j))
  }), e.createElement("div", {
    className: f(je, Ae(u), z({}, Te, R))
  }), e.createElement("div", {
    ref: E,
    onScroll: function onScroll(e) {
      e.persist(), C(e);
    },
    className: f(p(ye || (ye = I(["\n            overflow-x: auto;\n          "]))))
  }, e.createElement("table", F({
    cellSpacing: "0",
    cellPadding: "0",
    className: f(Ce, z({}, p(be || (be = I(["\n                border-bottom: 1px solid ", ";\n                font-family: ", ";\n              "])), g.gray.dark1, m.legacy), u), l)
  }, h), e.createElement(Z, {
    data: a
  }, e.createElement(ee, null, e.createElement(ie, {
    baseFontSize: O
  }, e.createElement(se, {
    darkMode: u
  }, e.createElement(X, {
    columns: t
  }), e.createElement(oe, null, i))))))));
}

var De,
    Me,
    We,
    _e,
    Be,
    Le,
    Ue,
    Ve,
    Ge,
    Je = p(ve || (ve = I(["\n  --lg-cell-padding-block: 10px;\n  min-width: 40px;\n  padding: var(--lg-cell-padding-block) 8px;\n  box-sizing: border-box;\n  vertical-align: baseline;\n  text-align: left; // Justification is updated in `Row.tsx` for number cells\n"], ["\n  --lg-cell-padding-block: 10px;\n  min-width: 40px;\n  padding: var(--lg-cell-padding-block) 8px;\n  box-sizing: border-box;\n  vertical-align: baseline;\n  text-align: left; // Justification is updated in \\`Row.tsx\\` for number cells\n"]))),
    qe = function qe(e, n) {
  return p(16 === e ? we || (we = I(["\n      ", "\n      font-size: 16px;\n      line-height: 24px;\n    "])) : n ? xe || (xe = I(["\n      --lg-cell-padding-block: 8px;\n      ", "\n      font-size: 14px;\n      line-height: 20px;\n    "])) : ke || (ke = I(["\n    ", "\n    font-size: 13px;\n    line-height: 20px;\n  "])), Je);
},
    Ze = ["children", "className", "isHeader", "isDisabled"],
    $e = k("td-inner-div"),
    Ke = p(De || (De = I(["\n  line-height: 20px;\n  position: relative;\n"]))),
    Qe = p(Me || (Me = I(["\n  font-weight: 600;\n"]))),
    Xe = p(We || (We = I(["\n  border-right: 3px solid ", ";\n  background-color: ", ";\n"])), h.gray.light2, h.gray.light3),
    Ye = p(_e || (_e = I(["\n  border-right: 3px solid ", ";\n  background-color: ", ";\n"])), h.gray.dark1, h.gray.dark2),
    en = p(Be || (Be = I(["\n  display: flex;\n  align-items: center;\n"]))),
    nn = p(Le || (Le = I(["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  color: ", ";\n  cursor: auto;\n"])), h.gray.light3, h.gray.light3, h.black),
    rn = p(Ue || (Ue = I(["\n  color: ", ";\n  cursor: auto;\n"])), h.white),
    tn = c(function (n, r) {
  var t,
      o = n.children,
      a = n.className,
      i = n.isHeader,
      l = void 0 !== i && i,
      c = n.isDisabled,
      s = H(n, Ze),
      d = l ? "th" : "td",
      u = le(),
      m = de(),
      h = {
    ref: r,
    className: f(qe(u, m), Ke, (t = {}, z(t, Qe, l), z(t, Xe, l && !m), z(t, Ye, l && m), z(t, nn, l && c && !m), z(t, rn, l && c && m), t), a)
  };
  return l && (h.scope = "row", h.role = "rowheader"), e.createElement(d, F({}, h, s), e.createElement("div", F({
    className: en
  }, $e.prop), e.createElement("span", {
    className: p(Ve || (Ve = I(["\n              display: flex;\n            "])))
  }, o)));
});

tn.displayName = "Cell", function (e) {
  e.Browser = "browser", e.Server = "server", e.Native = "native";
}(Ge || (Ge = {}));

var on,
    an,
    ln,
    cn,
    sn,
    dn,
    un,
    pn,
    fn,
    mn,
    hn,
    gn,
    yn,
    bn,
    vn,
    wn,
    xn,
    kn = Ge.Browser,
    En = Ge.Server,
    Sn = Ge.Native,
    Nn = !("undefined" == typeof window || !window.document || !window.document.createElement),
    On = "undefined" != typeof navigator && "ReactNative" == navigator.product ? Sn : Nn ? kn : En,
    Cn = {
  isBrowser: On === kn,
  isServer: On === En,
  isNative: On === Sn,
  device: On,
  canUseWorkers: "undefined" != typeof Worker,
  canUseEventListeners: On === kn && !!window.addEventListener,
  canUseViewport: On === kn && !!window.screen
},
    jn = function () {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
    n[r] = arguments[r];
  }

  return n.reduce(function (e, n) {
    return P(P({}, e), n);
  }, {});
}((on = Cn, Object.keys(on).map(function (e) {
  return on[e];
}), Cn)),
    Rn = ["ref", "className", "state"],
    An = p(an || (an = I(["\n  position: relative;\n  opacity: 0;\n  transform-origin: 50% 0%;\n  transition: ", 'ms ease-in-out;\n  transition-property: outline-color, opacity;\n\n  // This makes it so that any tall nested rows appear "below" the parents\n  // This may cause issues if there are multiple levels of nesting\n  // that all have more than one line of text. However this scenario is unlikely\n  z-index: 0;\n\n  & > :is(td, th) {\n    transition: ', "ms ease-in-out;\n    transition-property: padding-block;\n\n    & > ", " {\n      transition: ", "ms ease-in-out;\n      transition-property: min-height, max-height;\n    }\n  }\n"])), 200, 200, $e.selector, 200),
    Tn = p(ln || (ln = I(["\n  opacity: 0;\n  outline-color: transparent;\n\n  & > :is(td, th) {\n    padding-block: 0;\n\n    & > ", " {\n      min-height: 0px;\n      max-height: 0px;\n    }\n  }\n"])), $e.selector),
    Pn = function Pn(e, n) {
  return "entered" === e ? p(cn || (cn = I(["\n        opacity: 1;\n        & > :is(td, th) {\n          & > ", " {\n            --lg-cell-max-height: max(var(--lg-cell-min-height), ", "px);\n            min-height: var(--lg-cell-min-height);\n            max-height: var(--lg-cell-max-height);\n          }\n        }\n      "])), $e.selector, n) : Tn;
},
    zn = function zn(n) {
  n.ref;
  var t = n.className,
      o = n.state,
      a = H(n, Rn),
      l = D(i(0), 2),
      c = l[0],
      d = l[1],
      u = de(),
      m = s(null);
  return r(function () {
    !function () {
      if (m && m.current) {
        var e = m.current.querySelector("".concat($e.selector, " > span"));
        e && e.offsetHeight && d(e.offsetHeight);
      }
    }();
  }, [m.current]), e.createElement(Ln, F({}, a, {
    ref: m,
    className: f(An, Pn(o, c), z({}, p(sn || (sn = I(["\n            --lg-cell-min-height: 24px;\n          "]))), u), t)
  }));
},
    Fn = ["expanded", "disabled", "indentLevel", "isAnyAncestorCollapsed", "children", "className"],
    Hn = ["children"],
    In = "light",
    Dn = "dark",
    Mn = p(dn || (dn = I(["\n  margin: -4px;\n  margin-right: 4px;\n"]))),
    Wn = (z(yn = {}, In, {
  rowStyle: p(un || (un = I(["\n      background-color: ", ";\n      color: ", ";\n    "])), h.white, h.gray.dark3),
  altColor: p(pn || (pn = I(["\n      &:nth-of-type(even) {\n        background-color: ", ";\n      }\n\n      &:nth-of-type(odd) > th {\n        background-color: ", ";\n      }\n    "])), h.gray.light3, h.white),
  disabledStyle: p(fn || (fn = I(["\n      background-color: ", ";\n      color: ", ";\n      border-top: 1px inset ", ";\n      border-bottom: 1px inset ", ";\n    "])), h.gray.light2, h.gray.base, h.gray.light1, h.gray.light1)
}), z(yn, Dn, {
  rowStyle: p(mn || (mn = I(["\n      background-color: ", ";\n      color: ", ";\n      box-shadow: 0 -1px 0 inset ", ";\n    "])), g.gray.dark3, g.gray.light3, g.gray.dark1),
  altColor: p(hn || (hn = I(["\n      &:nth-of-type(even) {\n        background-color: ", ";\n      }\n\n      &:nth-of-type(odd) > th {\n        background-color: ", ";\n      }\n\n      > th {\n        box-shadow: 0 -1px 0 inset ", ";\n      }\n    "])), g.gray.dark2, h.gray.dark3, g.gray.dark1),
  disabledStyle: p(gn || (gn = I(["\n      background-color: ", ";\n      color: ", ";\n    "])), g.gray.dark1, g.gray.base)
}), yn),
    _n = p(bn || (bn = I(["\n  --lg-cell-min-height: 20px;\n  position: relative;\n  z-index: 1;\n\n  & > :is(td, th) > ", " {\n    min-height: var(--lg-cell-min-height);\n    max-height: unset;\n  }\n"])), $e.selector),
    Bn = p(vn || (vn = I(["\n  opacity: 0;\n"])));

var Ln = c(function (n, o) {
  var a,
      l = n.expanded,
      c = void 0 !== l && l,
      d = n.disabled,
      u = void 0 !== d && d,
      m = n.indentLevel,
      h = void 0 === m ? 0 : m,
      g = n.isAnyAncestorCollapsed,
      y = n.children,
      b = n.className,
      w = H(n, Fn),
      k = jn.isBrowser,
      E = $(),
      j = E.state,
      R = j.data,
      A = j.columnInfo,
      T = j.hasNestedRows,
      W = j.hasRowSpan,
      _ = E.dispatch,
      B = de(),
      V = B ? Dn : In,
      J = R && R.length >= 10 && null != T && !T,
      q = s(v({
    prefix: "row"
  })),
      Z = D(i(c), 2),
      K = Z[0],
      Q = Z[1],
      X = s(null);
  r(function () {
    var n = !1,
        r = !1;
    T && W || (e.Children.forEach(y, function (e) {
      !x(e, "Row") || n || T || (n = !0), x(e, "Cell") && e.props.rowSpan && e.props.rowSpan > 1 && !W && !r && (r = !0);
    }), n && T !== n && _({
      type: L,
      payload: !0
    }), r && W !== r && _({
      type: U,
      payload: !0
    }));
  }, [y, T, W, _, R]);
  var Y = t(function () {
    var n = [],
        r = e.Children.toArray(y).some(function (e) {
      return x(e, "Row");
    }),
        t = K && !g;
    return {
      rowHasNestedRows: r,
      renderedNestedRows: n,
      renderedNestedRowTransitionGroup: k ? e.createElement(S, {
        in: t,
        timeout: {
          enter: 0,
          exit: 200
        },
        nodeRef: X
      }, function (n) {
        return e.Children.map(y, function (r, t) {
          if (null != r && x(r, "Row")) return e.createElement(zn, F({
            isAnyAncestorCollapsed: g || !K,
            indentLevel: h + 1,
            key: "".concat(q.current, "-").concat(h, "-").concat(t),
            state: n
          }, r.props));
        });
      }) : n
    };
  }, [y, K, g, k, h]),
      ee = Y.rowHasNestedRows,
      ne = Y.renderedNestedRowTransitionGroup,
      re = t(function () {
    var n = [];

    if (e.Children.forEach(y, function (r, t) {
      if (x(r, "Cell")) {
        if (null == r.props.children) return null;
        n.push(e.cloneElement(r, P({
          children: e.createElement("span", null, r.props.children),
          key: "".concat(q.current, "-").concat(t),
          isDisabled: u,
          isHeader: r.props.isHeader
        }, r.props)));
      }
    }), ee) {
      var r = K ? C : O,
          t = e.createElement(N, {
        onClick: function onClick() {
          return Q(function (e) {
            return !e;
          });
        },
        "aria-label": K ? "Collapse row" : "Expand row",
        "aria-expanded": K,
        className: Mn,
        darkMode: B
      }, e.createElement(r, {
        "aria-hidden": !0
      })),
          o = n[0].props,
          a = o.children,
          i = H(o, Hn);
      n[0] = e.cloneElement(n[0], P({
        children: e.createElement(e.Fragment, null, t, e.createElement("span", null, a)),
        key: "".concat(q.current, "-").concat(n[0].props.children)
      }, i));
    }

    return n;
  }, [y, ee, K, Q, B, u]),
      te = A ? Object.entries(A).map(function (e) {
    var n = D(e, 2);
    return function (e, n) {
      var r;
      return r = n === G.Number ? "flex-end" : "flex-start", p(wn || (wn = I(["\n    & :is(td, th):nth-child(", ") > div {\n      justify-content: ", ";\n    }\n  "])), e, r);
    }(n[0], n[1].dataType);
  }) : [""],
      oe = f(_n, Wn[V].rowStyle, function (e) {
    return p(xn || (xn = I(["\n    & > :is(td, th):nth-child(1) {\n      padding-left: ", "px;\n    }\n  "])), 8 + 36 * e);
  }(h), M(te), (z(a = {}, Bn, !A), z(a, Wn[V].altColor, J), z(a, Wn[V].disabledStyle, u), a), b);
  return e.createElement(e.Fragment, null, e.createElement("tr", F({
    role: "row",
    className: oe,
    "aria-disabled": u,
    ref: o,
    key: q.current
  }, w), re), ne);
});
Ln.displayName = "Row";
var Un,
    Vn,
    Gn,
    Jn,
    qn,
    Zn,
    $n,
    Kn,
    Qn,
    Xn,
    Yn,
    er,
    nr = ["label", "onClick", "index", "className", "dataType", "sortBy", "compareFn", "handleSort"],
    rr = "light",
    tr = "dark",
    or = (z($n = {}, rr, {
  thStyle: p(Un || (Un = I(["\n      border-color: ", ";\n    "])), h.gray.light2),
  labelStyle: p(Vn || (Vn = I(["\n      color: ", ";\n    "])), h.gray.dark3),
  glyphColor: p(Gn || (Gn = I(["\n      color: ", ";\n    "])), h.blue.base)
}), z($n, tr, {
  thStyle: p(Jn || (Jn = I(["\n      background-color: ", ";\n      border-color: ", ";\n    "])), g.gray.dark3, g.gray.dark1),
  labelStyle: p(qn || (qn = I(["\n      color: ", ";\n    "])), g.gray.light3),
  glyphColor: p(Zn || (Zn = I(["\n      color: ", ";\n    "])), g.blue.light1)
}), $n),
    ar = p(Kn || (Kn = I(["\n  border-bottom: 3px solid;\n"]))),
    ir = p(Qn || (Qn = I(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]))),
    lr = p(Xn || (Xn = I(["\n  padding-right: 4px;\n"]))),
    cr = p(Yn || (Yn = I(["\n  margin: -4px 0;\n"]))),
    sr = {
  unsorted: A,
  asc: R,
  desc: j
};

function dr(n) {
  var r = n.label;
  n.onClick;
  var t = n.index,
      o = n.className,
      a = n.dataType,
      i = n.sortBy,
      l = n.compareFn,
      c = n.handleSort,
      s = H(n, nr),
      d = $().dispatch,
      u = ne(),
      m = u.sort,
      h = u.setSort,
      g = le(),
      y = de(),
      b = y ? tr : rr;
  e.useEffect(function () {
    "number" == typeof t && d({
      type: B,
      payload: {
        index: t + 1,
        dataType: a
      }
    });
  }, [t, a, d]);

  var v,
      w = i && function (e) {
    var n = e;
    if ("string" == typeof e) if (e.includes(".")) {
      var r = e.split(".");

      n = function n(e) {
        return r.reduce(function (e, n) {
          return e[n];
        }, e);
      };
    } else n = function n(_n2) {
      return _n2[e];
    };
    return n;
  }(i),
      x = !!(i || l || c),
      k = m && m.columnId === t ? m.direction : null,
      S = null != k ? k : "unsorted",
      O = sr[S];

  switch (k) {
    case "asc":
      v = "ascending";
      break;

    case "desc":
      v = "descending";
      break;

    case null:
      v = "none";
      break;

    default:
      E(k);
  }

  return e.createElement("th", F({
    role: "columnheader",
    scope: "col",
    "aria-sort": v
  }, s, {
    className: f(qe(g), ar, or[b].thStyle, z({}, p(er || (er = I(["\n            font-size: 14px;\n            border-width: 0px 1px 3px 1px;\n          "]))), y), o)
  }), e.createElement("div", {
    className: ir
  }, e.createElement("span", {
    className: f(lr, or[b].labelStyle)
  }, r), x && e.createElement(N, {
    className: cr,
    "aria-label": "sort",
    onClick: function onClick() {
      if ("number" == typeof t && x) {
        var e = t === (null == m ? void 0 : m.columnId) ? "asc" === m.direction ? "desc" : "asc" : "desc";
        h(function (n) {
          return {
            columnId: t,
            direction: e,
            accessorValue: w || void 0,
            compareFn: l
          };
        }), null == c || c(e);
      }
    },
    darkMode: y
  }, e.createElement(O, {
    size: "small",
    title: "".concat(S, "-").concat(t),
    className: f(z({}, or[b].glyphColor, "asc" === S || "desc" === S))
  }))));
}

dr.displayName = "TableHeader";
export { tn as Cell, G as DataType, Q as HeaderRow, Ln as Row, Ie as Table, dr as TableHeader };